import React, { useState } from 'react';
import { Row } from 'react-bootstrap';
import i18n from 'utils/I18n';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import CustomButton from 'component/base/CustomButton';
import DownloadQRcode from 'component/campaign/DownloadQRcode';
import { getMaxCashDollar } from '../profile/PointAndCashSection';
import { ReleasePointsButtonWithModal } from '../profile/UseCashDollar';
import { enLocaleNumberFormatter } from 'utils';
import { APP_NAME } from 'utils/Config';
import { navigateBackHomePage } from 'utils/WeChatUtil'
import { isNotSimplifiedNoWebapp } from "utils/UIConfigUtils";
import { useMemo } from 'react';
import { useCallback } from 'react';

const mapStateToProps = ({ users }) => ({
  availablePoints: users.availablePoints,
  frozenPoints: users.frozenPoints,
});
const RequiredPointsInfo = ({
  availablePoints,
  frozenPoints,
  totalPointsToUse,
}) => {
  const history = useHistory();
  const balance = availablePoints - totalPointsToUse;
  const [showDownloadAppModal, setShowDownloadAppModal] = useState(false);

  const handleExploreOrDownloadClick = useCallback(() => {
    if (isNotSimplifiedNoWebapp()) {
      navigateBackHomePage({ history });
      return;
    }
    setShowDownloadAppModal(true);
  }, [history]);

  const pointsReminder = useMemo(() => {
    if (frozenPoints) {
      return (
        <Row>
          <label className='calculate_label body-1 color-g3'>
            {i18n.t("coupon_campaign_frozen_points", {
              frozenPoints: enLocaleNumberFormatter(frozenPoints),
              frozenCash: enLocaleNumberFormatter(getMaxCashDollar(frozenPoints)),
            })}
          </label>
          <div className='calculate_label'>
            <ReleasePointsButtonWithModal />
          </div>
        </Row>
      )
    }
    if (balance < 0) {
      return (
        <Row>
          <label className='calculate_label tag-menu-2 color-s4'>
            {isNotSimplifiedNoWebapp()
              ? i18n.t("no_enough_points_to_get_ticket")
              : i18n.t("no_enough_points_to_get_ticket_for_no_web")
            }
          </label>
          <div className='calculate_label'>
            <CustomButton
              className="button-small secondary-button"
              text={isNotSimplifiedNoWebapp()
                ? i18n.t("explore_campaigns_now")
                : i18n.t("event_download_app")
              }
              btnClicked={handleExploreOrDownloadClick}
              disabled={false}
            />
          </div>
        </Row>
      )
    }
    return <></>
  }, [frozenPoints, balance, handleExploreOrDownloadClick])

  return (
    <>
      <Row>
        <label className="block_label headline">{i18n.t('Total')}</label>
        <label className="required_points title-medium-2">
          {`${enLocaleNumberFormatter(totalPointsToUse)} ${i18n.t('points')}`}
        </label>
      </Row>
      <Row className="poins-to-use-row">
        <Row className="point_available_section">
          <label className="calculate_label first_label subheading">
            {i18n.t('point_avaliable')}
          </label>
          <label className="calculate_points total_points field-text">
            {`${enLocaleNumberFormatter(availablePoints)} ${i18n.t('points')}`}
          </label>
        </Row>
        <Row className="required_points_section">
          <label className="calculate_label subheading">
            {i18n.t('campaign_required_points')}
          </label>
          <label className="calculate_points field-text">
            {`-${enLocaleNumberFormatter(totalPointsToUse)} ${i18n.t('points')}`}
          </label>
        </Row>
        <Row className="balance_section">
          <label
            className={`calculate_label result_points subheading ${balance < 0 ? 'red_label' : ''}`}
          >
            {i18n.t('campaign_balance')}
          </label>
          <label
            className={`result_points field-text ${balance < 0 ? 'red_label' : ''}`}
          >
            {`${enLocaleNumberFormatter(balance)} ${i18n.t('points')}`}
          </label>
        </Row>
        {pointsReminder}
      </Row>
      <DownloadQRcode
        title={i18n.t('scan_to_download_app', { appName: APP_NAME })}
        show={showDownloadAppModal}
        onHide={() => setShowDownloadAppModal(false)}
      />
    </>
  );
}

export default connect(mapStateToProps)(RequiredPointsInfo);
